(function () {
  'use strict';
  document.querySelectorAll('.managed-product-carousel').forEach(function (carousel) {
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';
    var viewport = carousel.querySelector('.managed-carousel-viewport');
    var previous = carousel.querySelector('.managed-carousel-prev');
    var next = carousel.querySelector('.managed-carousel-next');
    var animation;
    function stopAnimation() {
      cancelAnimationFrame(animation);
    }
    // Native smooth scrolling has a browser-controlled duration. Animate explicitly
    // so the arrow controls have the same, slightly slower pace on every screen.
    function animateTo(target) {
      stopAnimation();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        viewport.scrollTo({ left: target, behavior: 'instant' });
        return;
      }
      var start = viewport.scrollLeft;
      var started = performance.now();
      function frame(now) {
        var progress = Math.min((now - started) / 650, 1);
        var eased = progress * progress * (3 - 2 * progress);
        viewport.scrollLeft = start + (target - start) * eased;
        if (progress < 1) animation = requestAnimationFrame(frame);
        else stopAnimation();
      }
      animation = requestAnimationFrame(frame);
    }
    viewport.addEventListener('pointerdown', stopAnimation);
    viewport.addEventListener('wheel', stopAnimation, { passive: true });
    function move(direction) {
      var end = viewport.scrollWidth - viewport.clientWidth;
      var target = viewport.scrollLeft + direction * viewport.clientWidth;
      if (direction > 0 && viewport.scrollLeft >= end - 2) target = 0;
      if (direction < 0 && viewport.scrollLeft <= 2) target = end;
      animateTo(Math.max(0, Math.min(end, target)));
    }
    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    viewport.addEventListener('keydown', function (event) {
      if (event.target !== viewport) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    function resize() {
      var overflow = viewport.scrollWidth > viewport.clientWidth + 2;
      previous.disabled = next.disabled = !overflow;
    }
    new ResizeObserver(resize).observe(viewport);
    resize();
  });
}());
